import { AccountBody } from '../../components/AccountSheet'

/** The phone's account sheet, its body only, at phone width as City is: the
 *  same Notes, theme, System, Venue admin and Sign out, one component. A desk
 *  design can replace this; until then nothing here is a second copy. */
export function Account() {
  return <div className="desk-phone"><AccountBody /></div>
}
